import InvalidTokenModal from '../../layouts/InvalidTokenModal';
import useInvalidTokenModal from '../../../hooks/useInvalidTokenModal';
import React from 'react';
import ProfileEditorDialog from '../ProfileEditorDialog';
import useProfileEditorDialog from '../../../hooks/useProfileEditorDialog';
import AddressesEditorDialog from '../AddressesEditorDialog';
import useFullScreenLoading from '../../../hooks/useFullScreenLoading';
import { FullScreenLoading } from '../../shared/FullScreenLoading';
import ConfirmDialog from '../ConfirmDialog';
import useConfirmDialog from '../../../hooks/dialogs/useConfirmDialog';
import InvoiceDetailsDialog from '../InvoiceDetailsDialog';
import useInvoiceDetailsDialog from '../../../hooks/dialogs/useInvoiceDetailsDialog';
import AdminUserAddressesEditorDialog from '../AdminUserAddressesEditor';
import useAddToCompanyDialog from '../../../hooks/useAddToCompanyDialog';
import AddToCompanyDialog from '../AddToCompanyDialog';

const ModalWrapper: React.FC = () => {
    const invalidTokenModal = useInvalidTokenModal();
    const profileDialog = useProfileEditorDialog();
    const addToCompanyDialog = useAddToCompanyDialog();
    const fullScreenLoading = useFullScreenLoading();
    const confirmDialog = useConfirmDialog();
    const invoiceDetailsDialog = useInvoiceDetailsDialog();

    return (
        <>
            <ProfileEditorDialog
                open={profileDialog.profileEditorStates.profile.open}
            />
            <AddressesEditorDialog
                open={profileDialog.profileEditorStates.address.open}
            />
            <AdminUserAddressesEditorDialog
                open={profileDialog.profileEditorStates.adminAddress.open}
            />
            <AddToCompanyDialog
                open={addToCompanyDialog.addToCompanyDialogState.open}
            />
            {fullScreenLoading.fullScreenLoadingStates && <FullScreenLoading />}
            <InvalidTokenModal open={invalidTokenModal.show} />
            <ConfirmDialog dialogContent={confirmDialog.dialogContent} />
            <InvoiceDetailsDialog open={invoiceDetailsDialog.open}/>
        </>
    );
};

export default ModalWrapper;
